"use client";

import React from "react";
import SectionHeading from "./section-heading";
import { motion } from "framer-motion";
import { useSectionInView } from "@/lib/hooks";
import { useI18nContext } from "@/context/i18n-context";

const EASE_OUT_QUART = [0.25, 1, 0.5, 1] as const;

export default function About() {
  const { t } = useI18nContext();
  const links: { name: string; hash: string }[] = t("links");
  const { ref } = useSectionInView(links[1]?.name ?? "About", 0.5);

  return (
    <motion.section
      ref={ref}
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: EASE_OUT_QUART }}
      className="w-full max-w-[52rem] mb-24 sm:mb-32 scroll-mt-28"
      id="about"
    >
      <SectionHeading>{t("about.title")}</SectionHeading>

      <div className="space-y-5 font-serif font-light leading-[1.8]
        text-[1rem] text-[var(--color-text-secondary)] max-w-[44rem]">
        <p>{t("about.first")}</p>
        <p>{t("about.second")}</p>
      </div>
    </motion.section>
  );
}
